function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.35,
    height: 10.5,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1666666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 5.25,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.5,
    width: 22.35,
    height: 10.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 15.985,
    fontFamily: "Arial"
  }, "\n        Glades\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.47,
    width: 22.35,
    height: 12.06,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7228571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 27.5,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.53,
    width: 22.35,
    height: 13.28,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4755555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 40.17,
    fontFamily: "Arial"
  }, "\n        Gilchrist\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 46.81,
    width: 22.35,
    height: 13.3,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 53.46,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.11,
    width: 22.35,
    height: 16.14,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3057142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 68.18,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76.26,
    width: 22.35,
    height: 16.95,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3899999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 84.735,
    fontFamily: "Arial"
  }, "\n        Dixie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 93.2,
    width: 22.35,
    height: 19.72,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.944
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 103.06,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.92,
    width: 22.35,
    height: 20.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.51875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 122.995,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 133.07,
    width: 22.35,
    height: 21.5,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0714285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 143.82,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154.57,
    width: 22.35,
    height: 23.53,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 166.33499999999998,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 178.09,
    width: 22.35,
    height: 25.52,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.192857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 190.85,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.61,
    width: 22.35,
    height: 27.09,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 217.155,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 230.7,
    width: 22.35,
    height: 27.18,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2350000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 244.29,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.89,
    width: 22.35,
    height: 28.4,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 272.09,
    fontFamily: "Arial"
  }, "\n        Gulf\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 286.28,
    width: 22.35,
    height: 29.74,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 301.15,
    fontFamily: "Arial"
  }, "\n        Hendry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 316.02,
    width: 22.35,
    height: 32.36,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 332.2,
    fontFamily: "Arial"
  }, "\n        DeSoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 348.38,
    width: 22.35,
    height: 35.03,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 365.895,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 383.42,
    width: 22.35,
    height: 35.11,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 400.975,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 418.53,
    width: 22.35,
    height: 35.76,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 436.40999999999997,
    fontFamily: "Arial"
  }, "\n        Hardee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.28,
    width: 22.35,
    height: 37.22,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2350000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 472.89,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 491.51,
    width: 22.35,
    height: 37.67,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.192857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 510.34499999999997,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 529.17,
    width: 22.35,
    height: 40.88,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 549.61,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 570.06,
    width: 22.35,
    height: 41.27,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 590.6949999999999,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 611.33,
    width: 22.35,
    height: 42.07,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 632.365,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.4,
    width: 22.35,
    height: 46.6,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.175,
    y: 676.6999999999999,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 0,
    width: 28.83,
    height: 42.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.765,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.18,
    y: 0,
    width: 32.63,
    height: 42.06,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4383333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.495,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.81,
    y: 0,
    width: 37.83,
    height: 42.06,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.72875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.725,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.64,
    y: 0,
    width: 37.93,
    height: 42.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.74125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.605,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.56,
    y: 0,
    width: 44.32,
    height: 42.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.72,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.88,
    y: 0,
    width: 50.21,
    height: 42.06,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.98499999999999,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.09,
    y: 0,
    width: 50.68,
    height: 42.06,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.43,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.77,
    y: 0,
    width: 51.68,
    height: 42.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.010000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.60999999999996,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.45,
    y: 0,
    width: 51.92,
    height: 42.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.206
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.40999999999997,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        St._John's\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.36,
    y: 0,
    width: 52.84,
    height: 42.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.010000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.78000000000003,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.2,
    y: 0,
    width: 54.72,
    height: 42.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.673333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.56,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Highlands\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.93,
    y: 0,
    width: 55.2,
    height: 42.06,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.53,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.12,
    y: 0,
    width: 64.25,
    height: 42.06,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.206
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.245,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.37,
    y: 0,
    width: 64.63,
    height: 42.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.010000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.685,
    y: 21.03,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 42.06,
    width: 63.8,
    height: 44.84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.736666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 64.48,
    fontFamily: "Arial"
  }, "\n        Indian_River\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 86.9,
    width: 63.8,
    height: 48.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 110.97500000000001,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 135.05,
    width: 63.8,
    height: 49.78,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.111428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 159.94,
    fontFamily: "Arial"
  }, "\n        Collier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 184.83,
    width: 63.8,
    height: 50,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 209.83,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 234.83,
    width: 63.8,
    height: 56.22,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 262.94,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 291.06,
    width: 63.8,
    height: 71.83,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 326.975,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 362.89,
    width: 63.8,
    height: 74.18,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.633333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 399.98,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 437.07,
    width: 63.8,
    height: 78.17,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 476.155,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 515.23,
    width: 63.8,
    height: 83.04,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 556.75,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.35,
    y: 598.28,
    width: 63.8,
    height: 101.72,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.25,
    y: 649.14,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.14,
    y: 42.06,
    width: 71.44,
    height: 105.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.205714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.86,
    y: 94.98,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.58,
    y: 42.06,
    width: 72.9,
    height: 105.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.580000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.03000000000003,
    y: 94.98,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.48,
    y: 42.06,
    width: 73.37,
    height: 105.84,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.481428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.16499999999996,
    y: 94.98,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.86,
    y: 42.06,
    width: 77.29,
    height: 105.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.3225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.505,
    y: 94.98,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 42.06,
    width: 82.86,
    height: 105.84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.58,
    y: 94.98,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.01,
    y: 42.06,
    width: 109.7,
    height: 105.84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.86,
    y: 94.98,
    fontFamily: "Arial"
  }, "\n        Sarasota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.71,
    y: 42.06,
    width: 126.29,
    height: 105.84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.855,
    y: 94.98,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.14,
    y: 147.89,
    width: 120.44,
    height: 117.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.78142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.36,
    y: 206.625,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.14,
    y: 265.36,
    width: 120.44,
    height: 122,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.36,
    y: 326.36,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.14,
    y: 387.35,
    width: 120.44,
    height: 125.58,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.205714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.36,
    y: 450.14000000000004,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.14,
    y: 512.93,
    width: 120.44,
    height: 187.07,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.073333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.36,
    y: 606.4649999999999,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.58,
    y: 147.89,
    width: 157.05,
    height: 181.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.705000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.105,
    y: 238.59499999999997,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.63,
    y: 147.89,
    width: 159.46,
    height: 181.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.288333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.36,
    y: 238.59499999999997,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.09,
    y: 147.89,
    width: 176.91,
    height: 181.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 35.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.5450000000001,
    y: 238.59499999999997,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.58,
    y: 329.31,
    width: 270.44,
    height: 180.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.54125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.8,
    y: 419.475,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.58,
    y: 509.64,
    width: 270.44,
    height: 190.36,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.194285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.8,
    y: 604.8199999999999,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.02,
    y: 329.31,
    width: 222.98,
    height: 370.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 55.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.51,
    y: 514.655,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1972);
export default __webpack_public_path__ + "static/media/1972.0ada63273682f479de0915a154b44a4a.svg";
export { ForwardRef as ReactComponent };